import React, { memo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './Modal.module.less';
import { Modal } from 'antd';
// import { logging } from '../../actions/log';

// const selectLogInfo = createSelector(
//   state => state.log,
//   log => log.logInfo,
// );
export default memo(({ maskStyle, containerStyle, title = '温馨提示', children, handleClose }) => {
  // const logInfoData = useSelector(selectLogInfo);
  const handleCloseX = () => {
    if (handleClose) {
      handleClose();
    }
  };
  return (
    <Modal
      wrapClassName={classNames(styles.mask, maskStyle)}
      visible={true}
      closable={false}
      footer={null}
      maskStyle={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        background: maskStyle ? 'transparent' : '808080',
      }}
      bodyStyle={{ padding: 0, margin: 0 }}
      width="fit-content"
      style={{ top: 0, paddingBottom: 0 }}
    >
      <div className={classNames(styles.popUp, containerStyle)}>
        <div className={styles.popUp_close}>
          <span className={styles.icon} onClick={handleCloseX}>
            <i className="iconfont icon-close" />
          </span>
        </div>
        <div className={styles.popUp_title} title={title}>
          {title}
        </div>
        <div>{children}</div>
      </div>
    </Modal>
  );
});
